// TODO: VSO:3543652 - Get rid of this code. Instead, meke Front Door SDK expose it and consume it here.
export var AUDIO_SAMPLE_RATE = 16000;
export var AUDIO_BITS_PER_SAMPLE = 16;
export var encodeWAVWithoutHeader = function (samples, sampleRate) {
    var audioFrame = downSampleAudioFrame(samples, sampleRate, AUDIO_SAMPLE_RATE);
    var buffer = new ArrayBuffer(audioFrame.length * 2);
    var view = new DataView(buffer);
    floatTo16BitPCM(view, 0, audioFrame);
    return view;
};
var downSampleAudioFrame = function (srcFrame, srcRate, dstRate) {
    if (dstRate === srcRate || dstRate > srcRate)
        return srcFrame;
    if (srcFrame == null)
        return new Float32Array(0);
    var ratio = srcRate / dstRate;
    var dstLength = Math.round(srcFrame.length / ratio);
    var dstFrame = new Float32Array(dstLength);
    var srcOffset = 0;
    var dstOffset = 0;
    while (dstOffset < dstLength) {
        var nextSrcOffset = Math.round((dstOffset + 1) * ratio);
        var accum = 0;
        var count = 0;
        while (srcOffset < nextSrcOffset && srcOffset < srcFrame.length) {
            accum += srcFrame[srcOffset];
            srcOffset += 1;
            count += 1;
        }
        dstFrame[dstOffset] = accum / count;
        dstOffset += 1;
    }
    return dstFrame;
};
var floatTo16BitPCM = function (output, offset, input) {
    for (var i = 0, off = offset; i < input.length; i += 1, off += 2) {
        var s = Math.max(-1, Math.min(1, input[i]));
        output.setInt16(off, s < 0 ? s * 0x8000 : s * 0x7fff, true);
    }
};
//# sourceMappingURL=AudioUtils.js.map